import { TMobileSignupForm } from './form';
import {
  companyFormToStatePutBody,
  personalFormToStatePutBody,
} from './mapping';
import { fetchPutAndGetState } from '../../../api/lendingApi/lendingApiMutations';
import { useGetStateQuery } from '../../../api/lendingApi/lendingApiQueries';
import { useContextStateKey } from '../../../hooks/useContextStateKey';
import { TGetStateResponseDE } from '../../../lapiOverrideTypesDE';

export function useMobileSignupPersistence() {
  const stateKey = useContextStateKey();
  const { state } = useGetStateQuery<TGetStateResponseDE>();

  // The context should be resolved well before these screens. If it isn't, the
  // stage PUT is the only backend write for this stage, so throw rather than
  // advance with silent data loss — useScreenValidation blocks, logs, and
  // surfaces the inline error, and the user can retry once the context loads.
  const contextNotReadyError = (stage: string) =>
    new Error(
      `MobileSignup: ${stage} stage PUT attempted before context ready`,
    );

  const putCompanyStage = async (form: TMobileSignupForm) => {
    if (!stateKey || !state) throw contextNotReadyError('company');
    await fetchPutAndGetState({
      body: companyFormToStatePutBody(state, form),
      stateKey,
    });
  };

  const putPersonalStage = async (form: TMobileSignupForm) => {
    if (!stateKey || !state) throw contextNotReadyError('personal');
    await fetchPutAndGetState({
      body: personalFormToStatePutBody(state, form),
      stateKey,
    });
  };

  return { putCompanyStage, putPersonalStage };
}
